import useExport from 'packages/variation-export/hooks/useExport';
import useCommonExportPreset from 'packages/hooks/useExportPreset';

const useExportPreset = () => {
    const { isWaitingRoomBlocked, isDownloadBlocked } = useExport();

    return useCommonExportPreset({ isWaitingRoomBlocked, isDownloadBlocked });
};

export default useExportPreset;
